import { OneArchiveGroupDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import {
  OneCreateAction,
  OneCreationActionResolver,
} from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useArchiveGroupActionResolver: OneCreationActionResolver = () => {
  const [archiveGroup, { loading }] = useMutation(OneArchiveGroupDocument, {
    extractorFn: (data) => data.postsMutations.archivePostsGroup,
    errorPolicy: 'all',
  })

  const archiveGroupHandler = async (args: { groupId: string }) => {
    const result = await archiveGroup({
      variables: {
        id: args.groupId,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      return { success: true as const, data: args }
    }

    return handled
  }

  return {
    resolver: archiveGroupHandler,
    loading,
  }
}

export const ArchiveGroupAction: OneCreateAction = {
  actionResolver: useArchiveGroupActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
